import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { getEncuestas, setFormulario } from "../actions";

import {
  Container,
  Row,
  Col,
  Button,
  ListGroup,
  ListGroupItem,
} from "react-bootstrap";

//import Button from "react-bootstrap/Button";
//import Form from "react-bootstrap/Form";

const FormIniciativaFiltro = (props) => {
  const dispatch = useDispatch();

  const [values, setValues] = useState({
    nombre: props.inicio.nombre,
    codigo: props.inicio.codigo,
    estado: props.inicio.estado,
  });

  const [submitted, setSubmitted] = useState(false);

  const handleInputChange = (event) => {
    event.persist();
    setValues((values) => ({
      ...values,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);

    //console.log("values", values);

    const _params = {
      Token: "c3649ba4e3a81815",
      Function: "GetCmdicEncuestaLista",
      Parameters: {
        identificador: "0",
        id_equipo: 11,
      },
    };
    dispatch(getEncuestas(_params));
    dispatch(setFormulario({ campo: "filtroIniciativa", valor: values }));
  };
  //console.log("componente", props);

  return (
    <div>
      <form className="" onSubmit={handleSubmit}>
        {/* Uncomment the next line to show the success message */}
        {/* <div class="success-message">Success! Thank you for registering</div> */}
        <div className="row g-1">
          <div className="col-4">
            <div className="row">
              <div className="col-3">
                <label
                  for="estado"
                  class="col-form-label col-form-label-sm justify-content-end"
                >
                  Rut Vecino
                </label>
              </div>

              <div className="col-8">
                <input
                  id="codigo"
                  className="form-control form-control-sm"
                  type="text"
                  placeholder=""
                  name="codigo"
                  value={values.codigo}
                  onChange={handleInputChange}
                />
              </div>
              <div></div>
            </div>
            <div className="row">
              <div className="col-3">
                <label
                  for="estado"
                  class="col-form-label col-form-label-sm justify-content-end"
                >
                  Nombre
                </label>
              </div>

              <div className="col-8">
                <input
                  id="factura"
                  className="form-control form-control-sm"
                  type="text"
                  placeholder=""
                  name="factura"
                  value={values.factura}
                  onChange={handleInputChange}
                />
              </div>
              <div></div>
            </div>
            <div className="row">
              <div className="col-3">
                <label
                  for="estado"
                  class="col-form-label col-form-label-sm justify-content-end"
                >
                  Motivo
                </label>
              </div>

              <div className="col-8">
                <input
                  id="numpedido"
                  className="form-control form-control-sm"
                  type="text"
                  placeholder=""
                  name="numpedido"
                  value={values.numpedido}
                  onChange={handleInputChange}
                />
              </div>
              <div></div>
            </div>
            <div className="row">
              <div className="col-3">
                <label
                  for="estado"
                  class="col-form-label col-form-label-sm justify-content-end"
                >
                  Unidad Responsable
                </label>
              </div>

              <div className="col-8">
                <input
                  id="estado"
                  className="form-control form-control-sm"
                  type="text"
                  placeholder=""
                  name="estado"
                  value={values.estado}
                  onChange={handleInputChange}
                />
              </div>
              <div></div>
            </div>

            <div className="row">
              <div className="col-3">
                <label
                  for="estado"
                  class="col-form-label col-form-label-sm justify-content-end"
                >
                  Tipo de Caso
                </label>
              </div>

              <div className="col-8">
                <input
                  id="sucursal"
                  className="form-control form-control-sm"
                  type="text"
                  placeholder=""
                  name="sucursal"
                  value={values.sucursal}
                  onChange={handleInputChange}
                />
              </div>
              <div></div>
            </div>
            <div className="row">
              <div className="col-3">
                <label
                  for="estado"
                  class="col-form-label col-form-label-sm justify-content-end"
                >
                  Categoria
                </label>
              </div>

              <div className="col-8">
                <input
                  id="vendedor"
                  className="form-control form-control-sm"
                  type="text"
                  placeholder=""
                  name="vendedor"
                  value={values.vendedor}
                  onChange={handleInputChange}
                />
              </div>
              <div></div>
            </div>
            <div className="row">
              <div className="col-3">
                <label
                  for="estado"
                  class="col-form-label col-form-label-sm justify-content-end"
                >
                  Observaciones
                </label>
              </div>

              <div className="col-8">
                <textarea
                  id="vendedor"
                  className="form-control form-control-sm"
                  type="textarea"
                  placeholder=""
                  name="vendedor"
                  value={values.vendedor}
                  onChange={handleInputChange}
                ></textarea>
              </div>
              <div></div>
            </div>
            <br />
            <div className="col">
              <p className="text-danger fs-6">Alertas</p>
              <div class="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value=""
                  id="flexCheckDefault"
                ></input>
                <label className="form-check-label" for="flexCheckDefault">
                  Tiempo máximo superado
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="flexCheckChecked"
                ></input>
                <label class="form-check-label" for="flexCheckChecked">
                  Derivacion VIP
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="flexCheckChecked"
                ></input>
                <label class="form-check-label" for="flexCheckChecked">
                  Audiencia Agendada
                </label>
              </div>
            </div>
          </div>
          <div className="col-4">
            <Row>
              <Col>
                <span className="text-danger fs-6">Fecha de Solicitud</span>
              </Col>
            </Row>
            <div className="row">
              <div className="col-5">
                <label
                  for="estado"
                  class="col-form-label col-form-label-sm justify-content-end"
                >
                  Inicio
                </label>
              </div>

              <div className="col-6">
                <input
                  id="fechaini"
                  className="form-control form-control-sm"
                  type="text"
                  placeholder="12/10/2022"
                  name="fechaini"
                  value={values.fechaini}
                  onChange={handleInputChange}
                />
              </div>

              <div></div>
            </div>
            <div className="row">
              <div className="col-5">
                <label
                  for="estado"
                  class="col-form-label col-form-label-sm justify-content-end"
                >
                  Término
                </label>
              </div>

              <div className="col-6">
                <input
                  id="fechatermino"
                  className="form-control form-control-sm"
                  type="text"
                  placeholder="12/10/2022"
                  name="fechatermino1"
                  value={values.fechatermino1}
                  onChange={handleInputChange}
                />
              </div>
              <div></div>
            </div>
            <Row>
              <Col>
                <span className="text-danger fs-6">Fecha de Derivación</span>
              </Col>
            </Row>
            <div className="row">
              <div className="col-5">
                <label
                  for="estado"
                  class="col-form-label col-form-label-sm justify-content-end"
                >
                  Inicio
                </label>
              </div>

              <div className="col-6">
                <input
                  id="fechaini"
                  className="form-control form-control-sm"
                  type="text"
                  placeholder="12/10/2022"
                  name="fechaini2"
                  value={values.fechaini2}
                  onChange={handleInputChange}
                />
              </div>

              <div></div>
            </div>
            <div className="row">
              <div className="col-5">
                <label
                  for="estado"
                  class="col-form-label col-form-label-sm justify-content-end"
                >
                  Término
                </label>
              </div>

              <div className="col-6">
                <input
                  id="fechatermino"
                  className="form-control form-control-sm"
                  type="text"
                  placeholder="12/10/2022"
                  name="fechatermino2"
                  value={values.fechatermino2}
                  onChange={handleInputChange}
                />
              </div>
              <div></div>
            </div>
            <Row>
              <Col>
                <span className="text-danger fs-6">Fecha de Audiencia</span>
              </Col>
            </Row>
            <div className="row">
              <div className="col-5">
                <label
                  for="estado"
                  class="col-form-label col-form-label-sm justify-content-end"
                >
                  Inicio
                </label>
              </div>

              <div className="col-6">
                <input
                  id="fechaini"
                  className="form-control form-control-sm"
                  type="text"
                  placeholder="12/10/2022"
                  name="fechaini3"
                  value={values.fechaini3}
                  onChange={handleInputChange}
                />
              </div>

              <div></div>
            </div>
            <div className="row">
              <div className="col-5">
                <label
                  for="estado"
                  class="col-form-label col-form-label-sm justify-content-end"
                >
                  Término
                </label>
              </div>

              <div className="col-6">
                <input
                  id="fechatermino"
                  className="form-control form-control-sm"
                  type="text"
                  placeholder="12/10/2022"
                  name="fechatermino3"
                  value={values.fechatermino3}
                  onChange={handleInputChange}
                />
              </div>
              <div></div>
            </div>
            <Row>
              <Col>
                <span className="text-danger fs-6">Fecha de Cierre</span>
              </Col>
            </Row>
            <div className="row">
              <div className="col-5">
                <label
                  for="estado"
                  class="col-form-label col-form-label-sm justify-content-end"
                >
                  Inicio
                </label>
              </div>

              <div className="col-6">
                <input
                  id="fechaini"
                  className="form-control form-control-sm"
                  type="text"
                  placeholder="12/10/2022"
                  name="fechaini4"
                  value={values.fechaini4}
                  onChange={handleInputChange}
                />
              </div>

              <div></div>
            </div>

            <div className="row">
              <div className="col-5">
                <label
                  for="estado"
                  class="col-form-label col-form-label-sm justify-content-end"
                >
                  Término
                </label>
              </div>

              <div className="col-6">
                <input
                  id="fechatermino"
                  className="form-control form-control-sm"
                  type="text"
                  placeholder="12/10/2022"
                  name="fechatermino4"
                  value={values.fechatermino4}
                  onChange={handleInputChange}
                />
              </div>
              <div></div>
            </div>
          </div>
          <div className="col-2">
            <p className="text-secondary fs-6">Estado</p>
            <div class="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                value=""
                id="flexCheckDefault"
              ></input>
              <label className="form-check-label" for="flexCheckDefault">
                Pendiente sin Derivar
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                value=""
                id="flexCheckChecked"
              ></input>
              <label class="form-check-label" for="flexCheckChecked">
                Derivada Ex Ante
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                value=""
                id="flexCheckChecked"
              ></input>
              <label class="form-check-label" for="flexCheckChecked">
                Audiencia Agendada
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                value=""
                id="flexCheckChecked"
              ></input>
              <label class="form-check-label" for="flexCheckChecked">
                Derivación Ex Post
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                value=""
                id="flexCheckChecked"
              ></input>
              <label class="form-check-label" for="flexCheckChecked">
                Cerrado con Solución
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                value=""
                id="flexCheckChecked"
              ></input>
              <label class="form-check-label" for="flexCheckChecked">
                Cerrado sin Solución
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                value=""
                id="flexCheckChecked"
              ></input>
              <label class="form-check-label" for="flexCheckChecked">
                Anulada
              </label>
            </div>
          </div>
          <div className="col-2">
            <div className="row">
              <div className="d-grid gap-2 col-8 mx-auto">
                <button className="btn btn-primary" type="button">
                  Filtrar {"     "}
                </button>
                <button className="btn btn-secondary btn-sm" type="button">
                  Limpiar filtros {"     "}
                </button>
              </div>
            </div>
            <br />
            <br />
          </div>
        </div>
      </form>
    </div>
  );
};

export default FormIniciativaFiltro;
